"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appLayoutClasses = void 0;
exports.appLayoutClasses = {
    container: {
        flexGrow: 1,
        backgroundColor: '#e5e5e5',
        justifyContent: 'center',
        paddingBottom: { xs: 0, md: '40px' },
    },
    spacing: {
        px: { xs: 4, lg: 8 },
        py: 4,
    },
};
